import DividerPromo from './DividerPromo';

export default DividerPromo;